import { memo, Suspense } from "react";

import { wrapPromise } from "@/lib/chillnn/wrap-promise";

import { useMfaSettings } from "@/hooks/use-auth-client";
import type { MFASettingsType, UpdateMfaSettingsResultType } from "@/hooks/use-auth-client/use-mfa-settings";

import { CircleLoadingScreen } from "@/components/ui/loading/circle-screen";

import { SettingsSecurityPresenter } from "./presenter";

export const SettingsSecurityContainer = memo(() => {
	const { fetchMfaSettings, updateMfaSettings } = useMfaSettings();
	const result = wrapPromise<MFASettingsType>(fetchMfaSettings());

	return (
		<Suspense fallback={<CircleLoadingScreen />}>
			<SettingsSecurityContainerInner read={() => result.read()} updateMfaSettings={updateMfaSettings} />
		</Suspense>
	);
});

const SettingsSecurityContainerInner = memo(
	({
		read,
		updateMfaSettings,
	}: {
		read: () => MFASettingsType; //
		updateMfaSettings: (mfaSettings: MFASettingsType) => Promise<UpdateMfaSettingsResultType>;
	}) => {
		const data = read();

		return <SettingsSecurityPresenter mfaSettings={data} updateMfaSettings={updateMfaSettings} />;
	},
);

SettingsSecurityContainer.displayName = "SettingsSecurityContainer";
